export default class SearchMomentModel {
  constructor({
    title,
    id,
    url,
    type,
  }) {
    this.title = title;
    this.id = id;
    this.url = url;
    this.type = type;
  }

  getTitle() {
    return this.title || '';
  }

  getId() {
    return this.id;
  }

  getUrl() {
    return this.url || '';
  }

  getType() {
    return this.type || '';
  }
}
